<template>
  <div
    :style="headlineTheme"
    :class="cssTheme"
    class="headline text-left headline-bg"
  >
    <component
      v-if="visibleSidePanel"
      v-bind="sidePanelPropos"
      :backup="backup"
      @save="onSave"
      @cancel="onCancel"
      @remove="onRemove"
      @change="editBackground"
      @openCustomBranding="editCustomBranding"
      @openCustomLogo="editCustomLogo"
      @openConfigureAnswer="editConfigureAnswer"
      :is="sidePanelDialog"
    ></component>

    <nav class="k-navbar">
      <div @click="forwardToCustomURL" class="logo">
        <img class="logo-image" :src="customStyle" id="web-logo" />
      </div>

      <div
        class="nav-items ml-auto headline-items align-items-center mr-3 p-1"
        v-show="!hideWhenNewPoll"
      >
        <div v-if="false" @click="onBack" class="nav-item text-size-14">
          <icon styles="mr-1 ml-2" type="backButton" />
          <span class="k-desktop">{{ $t('headline.back') }}</span>
        </div>

        <div v-if="isOwner" @click="onEditKulibri" class="nav-item">
          <font-awesome-icon class="mr-1 ml-2" :icon="['fal', 'cog']" />
          <span class="k-edit k-tablet">{{ $t('headline.edit') }}</span>
        </div>

        <div v-if="isOwner" @click="onEditInvites" class="nav-item">
          <font-awesome-icon class="mr-1 ml-2" :icon="['fal', 'share-alt']" />
          <span class="k-share k-tablet">{{ $t('headline.share') }}</span>
        </div>

        <div v-if="isOwner" @click="onSendReminder" class="nav-item k-desktop">
          <font-awesome-icon class="mr-1 ml-2" :icon="['fal', 'clock']" />
          <span class="k-tablet">{{ $t('headline.sendReminders') }}</span>
        </div>

        <div v-if="!isOwner" @click="onSendMessageToAdmin" class="nav-item">
          <font-awesome-icon class="mr-1 ml-2" :icon="['fal', 'envelope']" />
          <span class="k-tablet">{{ $t('headline.sendMessage') }}</span>
        </div>

        <div v-if="isOwner" @click="onDuplicate" class="nav-item k-desktop">
          <font-awesome-icon class="mr-1 ml-2" :icon="['fas', 'copy']" />
          <span class="k-share k-desktop">{{ $t('headline.duplicate') }}</span>
        </div>

        <div v-if="isOwner" @click="onExport" class="nav-item k-desktop">
          <font-awesome-icon class="mr-1 ml-2" :icon="['fas', 'file-export']" />
          <span class="k-share">{{ $t('headline.export') }}</span>
        </div>

        <div v-if="0" @click="onEditDates" class="nav-item">
          <font-awesome-icon class="mr-1 ml-2" :icon="['fal', 'clock']" />
          <span class="k-desktop">{{ $t('headline.dates') }}</span>
        </div>

        <div v-if="0" @click="onEditChoices" class="nav-item">
          <font-awesome-icon class="mr-1 ml-2" :icon="['fal', 'question']" />
          <span class="k-desktop">{{ $t('headline.choices') }}</span>
        </div>

        <div v-if="isOwner" @click="onEditClose" class="nav-item k-desktop">
          <span v-if="poll.closed">
            <font-awesome-icon class="mr-1 ml-2" :icon="['fas', 'lock-open']" />
            {{ $t('close.open') }}
          </span>
          <span v-else>
            <font-awesome-icon class="mr-1 ml-2" :icon="['fas', 'lock']" />
            {{ $t('close.close') }}
          </span>
        </div>

        <div v-if="isOwner" @click="removePollDlg" class="nav-item k-desktop">
          <font-awesome-icon class="mr-1 ml-2" :icon="['fal', 'trash-alt']" />
          <span class="k-remove k-desktop">{{ $t('headline.remove') }}</span>
        </div>

        <lang-options v-if="!isAuthenticated" />

        <nav-options
          v-if="isOwner"
          class="k-desktop-hide"
          :poll="poll"
          @edit="onEditKulibri"
          @invite="onEditInvites"
          @sendReminders="onSendReminder"
          @export="onExport"
          @duplicate="onDuplicate"
          @remove="removePollDlg"
          @close="onEditClose"
        />
        <nav-user />
      </div>
    </nav>

    <div :class="headlineCss" class="headline-content">
      <div class="text-project-header-admin">
        <div class="headline__left">
          <div class="headline__type">
            <font-awesome-icon
              class="mr-1 poll-type-icon"
              :icon="icon(poll.type)"
            />
            {{ polltype(this.poll.type) }} &nbsp;
          </div>
          <div class="user-details">
            {{ headline }}
          </div>
        </div>

        <a href="/pr/new" target="_blank" class="headline__middle new-poll">{{
          $t('polls.newPoll')
        }}</a>

        <Btn
          v-if="0"
          class="headline__middle"
          @click.native="onToggleDesign"
          label="Design"
        />
      </div>

      <div class="headline__name">
        <div class="headline__left">{{ poll.title }}</div>
      </div>
      <div class="headline__description">
        <div
          class="description"
          v-html="description"
          :class="[needToDisplayReadMore ? 'read-less' : '']"
        ></div>
        <div
          v-if="isDisplayReadMore"
          class="read-button text-uppercase"
          @click="openModal()"
          v-html="$t('headline.showAllDescription')"
        ></div>
      </div>
    </div>
    <ModalConfirm
      v-show="showConfirm | showCopyConfirm"
      :msg="titleConfirmRemove"
      :loading="false"
      @cancel="onRemoveCancel"
      @confirm="removePoll"
    />

    <ModalDialog
      ref="dlgCopyDialog"
      :title="$t('polls.copyConfirm')"
      :showCancelIcon="false"
      :displayCancelButton="true"
      :labelCancel="$t('general.no')"
      :displayOkButton="true"
      :labelOk="$t('general.yes')"
      @ok="confirmCopy()"
      @cancel="whenCancelDialog()"
    >
      <div
        v-if="poll.type != 2"
        class="d-flex justify-content-start aligh-item-start"
      >
        <ToggleOption v-model="copyOptions" icon="edit" class="d-flex">
          <div class="text-weight-semi-bold mb-2">
            {{ pollCopyOptions }}
          </div>

          <div v-if="0" class="text-size-10 pt-0 toggle-description">
            {{ $t('options.mayBeAnswersTip') }}
          </div>
        </ToggleOption>
      </div>
    </ModalDialog>

    <ModalDialog
      ref="dlgDescriptionDialog"
      :title="$t('headline.pollDescription')"
      :showCancelIcon="true"
      :displayCancelButton="false"
      @ok="closeDialog()"
      @cancel="closeDialog()"
      :displayOkButton="false"
    >
      <div class="description-text" v-html="description"></div>
    </ModalDialog>
  </div>
</template>

<script>
import shared from '@/shared.js';
import { HTTP } from '@/shared/http';

import Invite from '@/components/Invitations/Invite.vue';
import EditBackground from '@/components/Edit/EditBackground.vue';
import EditPoll from '@/components/Edit/EditPoll.vue';
import EditKulibri from '@/components/Edit/EditKulibri.vue';
import EditDates from '@/components/Edit/EditDates.vue';
import EditChoices from '@/components/Edit/EditChoices.vue';
import EditInvites from '@/components/Edit/EditInvites.vue';
import EditClose from '@/components/Edit/EditClose.vue';
import SendParticipantReminder from '@/components/Edit/SendParticipantReminder.vue';
import SendMessageToAdmin from '@/components/Edit/SendMessageToAdmin.vue';
import RenderHiddenMode from './RenderHiddenMode';
import EditLogo from '@/components/Edit/EditLogo.vue';
import CustomBranding from '@/components/Edit/CustomBranding.vue';
import ToggleOption from '@/components/Edit/ToggleOption.vue';

import ConfigureAnswer from '@/components/Edit/ConfigureAnswer.vue';

import { mapState, mapGetters, mapActions } from 'vuex';
import NavUser from '../UI/NavUser.vue';
import NavOptions from '../UI/NavOptions.vue';
import LangOptions from '../UI/LangOptions.vue';
import Icon from '../UI/Icon.vue';

import { themeMixin } from '../mixins/ThemeMixins';
import { pollMixin } from '@/components/mixins/PollMixins.js';
const customTemplate = require('../../shared/customTemplate');

function sprintf(format, ...args) {
  let i = 0;
  return format.replace(/%s/g, () => args[i++]);
}

export default {
  name: 'Headline',

  data() {
    return {
      subpanel: false,
      copyOptions: false,
      editingKulibri: false,
      editingDates: false,
      editingChoices: false,
      editingInvites: false,
      editingBackground: false,
      showSidePanel: false,
      sidePanelDialog: null,
      showConfirm: false,
      showCopyConfirm: false,
      backup: { title: null, description: null, options: null },
      backcupChoices: null,
      toggleReadMoreAndLess: true,
      needToDisplayReadMore: false,
      isNew: false,
      reRenderData: true,
      // hideNavBarWhenSidePanelOpen: true
    };
  },

  mixins: [themeMixin, pollMixin],

  components: {
    Invite,
    EditBackground,
    EditPoll,
    EditKulibri,
    EditDates,
    RenderHiddenMode,
    EditChoices,
    ToggleOption,
    EditInvites,
    NavUser,
    NavOptions,
    LangOptions,
    Icon,
    SendParticipantReminder,
    CustomBranding,
    EditLogo,
    ConfigureAnswer,
  },

  watch: {
    // if the user name is chnaged in the profile
    // and the user is the oner of the project
    // update the project owner name
    userName(newValue, oldValue) {
      console.error('Updating User name from:', oldValue, newValue);
      if (!this.isOwner) {
        return;
      }
      this.poll.user.name = this.userName;
    },
  },

  created() {
    window.addEventListener('resize', this.calculateTextWidth);
  },

  mounted() {
    this.$nextTick(function () {
      console.info(
        'check poll type and choices:',
        this.poll.type,
        this.poll.options.initialised
      );
      if (!this.poll.options.initialised) {
        console.info('check poll options:', this.poll.options);
        this.isNew = true;
        this.sidePanelDialog = EditPoll;

        // this.hideNavBar();

        let oldPollValue = localStorage.getItem('old-poll');
        if (oldPollValue) {
          oldPollValue = JSON.parse(oldPollValue);
          // new value instead of default
          this.poll.title = oldPollValue.title;
          this.poll.description = oldPollValue.description;
          this.poll.type = oldPollValue.type;
          this.poll.options = oldPollValue.options;
          this.poll.options.initialised = false;
          this.poll.bg_image_path = oldPollValue.bg_image_path;
          this.poll.choice_config = JSON.parse(
            JSON.stringify(oldPollValue.choice_config)
          );

          if (localStorage.getItem('copy-options') != null) {
            console.error('COPY OPTIONS');
            oldPollValue.choices.forEach((c) => {
              c.id = null;
            });
            this.$store.dispatch('updateChoices', oldPollValue.choices);
          }
          localStorage.removeItem('old-poll');
          let userImages = this.user ? this.user.images : [];
          let imageSrc = this.findImageFromListUsingURL(
            this.images,
            userImages,
            this.poll.bg_image_path,
            false
          );

          this.$store.commit('setBgImageOnlyForDisplay', imageSrc);
        }
        return;
      }

      if (this.poll.type != 2 && this.poll.choices.length == 0) {
        this.sidePanelDialog = EditDates;
        return;
      }
      this.calculateTextWidth();
    });
  },

  methods: {
    ...mapActions(['updateSelectedTemplate', 'updatePollStatus']),
    onToggleDesign() {
      this.$store.commit('toggleDesignAlignment');
    },

    addChoice() {
      let choice = {
        id: this.newId--,
        poll_id: this.poll.id,
        start: null,
        end: null,
        text: 'event',
        limit: null,
      };
      let choices = [...this.poll.choices, choice];
      console.log('add new event choice :', choices);
      this.$store.commit('updateChoicesNoSort', choices);
    },

    onEditDates() {
      this.sidePanelDialog = EditDates;
    },

    onEditKulibri() {
      // store the initial value before editing
      console.log('onEditKulibri activated');
      this.backup.title = this.poll.title;
      this.backup.description = this.poll.description;
      this.backup.options = JSON.parse(JSON.stringify(this.poll.options));
      this.backupChoices = JSON.parse(JSON.stringify(this.poll.choices));
      this.sidePanelDialog = EditPoll;
    },

    onEditInvites() {
      this.backupChoices = null;
      this.sidePanelDialog = EditInvites;
      // this.hideNavBar();
    },

    onEditClose() {
      this.backupChoices = null;
      this.sidePanelDialog = EditClose;
    },

    onEditChoices() {
      this.backup.options = JSON.parse(JSON.stringify(this.poll.options));
      this.backupChoices = JSON.parse(JSON.stringify(this.poll.choices));
      this.sidePanelDialog = EditChoices;
    },

    onRemove() {
      console.log('Headline - onRemove');
      this.removePoll();
    },

    onCancel() {
      this.reRenderData = true;
      console.info('Headline onCancel:', this.sidePanelDialog, this.subpanel);

      if (this.subpanel || this.sidePanelDialog.name == 'CustomBranding') {
        this.sidePanelDialog = EditPoll;
        this.subpanel = false;
        return;
      }

      if (this.sidePanelDialog === EditClose) {
        this.sidePanelDialog = null;
        return;
      }

      if (this.sidePanelDialog.name == 'EditPoll') {
        // traverse the loop to find updated value because when update the template,
        // template response will update the design array only so the poll array has old value that's why
        for (let i = 0; i < this.designs.length; i++) {
          if (this.designs[i]['id'] == this.poll.design_id) {
            this.updateSelectedTemplate(this.designs[i]);
            customTemplate.renderHTML(this.designs[i]);
            break;
          }
        }
      }

      // if in create mode -> delete the project
      if (
        this.sidePanelDialog === EditBackground ||
        this.sidePanelDialog === CustomBranding ||
        this.sidePanelDialog == ConfigureAnswer
      ) {
        let fromLastStop = localStorage.getItem('openFromCustomBranding');
        // This condition used to decide which component needs to open from the background image
        if (this.sidePanelDialog === EditBackground && fromLastStop == 'true') {
          this.sidePanelDialog = CustomBranding;
          localStorage.removeItem('openFromCustomBranding');
        } else {
          this.sidePanelDialog = EditPoll;
        }
      } else if (this.sidePanelDialog === EditLogo) {
        this.reRenderData = false;
        this.sidePanelDialog = CustomBranding;
      } else {
        this.sidePanelDialog = null;
        // if (this.backupChoices) {
        //   this.$store.dispatch('updateChoices', this.backupChoices).then(() => {
        //     this.backupChoices = null;
        //   });
        // }
      }
    },

    onCancelOld() {
      this.reRenderData = true;
      console.info('Headline onCancel:', this.sidePanelDialog, this.subpanel);

      if (
        this.subpanel ||
        this.sidePanelDialog.name == 'CustomBranding' ||
        this.sidePanelDialog.name == 'ConfigureAnswer'
      ) {
        this.sidePanelDialog = EditKulibri;
        this.subpanel = false;
        return;
      }

      if (this.sidePanelDialog === EditClose) {
        this.sidePanelDialog = null;
        // this.displayNavBar();
        return;
      }

      if (this.sidePanelDialog.name == 'EditKulibri') {
        // traverse the loop to find updated value because when update the template,
        // template response will update the design array only so the poll array has old value that's why
        for (let i = 0; i < this.designs.length; i++) {
          if (this.designs[i]['id'] == this.poll.design_id) {
            this.updateSelectedTemplate(this.designs[i]);
            customTemplate.renderHTML(this.designs[i]);
            break;
          }
        }
      }

      // if in create mode -> delete the project
      if (
        this.sidePanelDialog === EditBackground ||
        this.sidePanelDialog === CustomBranding
      ) {
        let fromLastStop = localStorage.getItem('openFromCustomBranding');
        // This condition used to decide which component needs to open from the background image
        if (this.sidePanelDialog === EditBackground && fromLastStop == 'true') {
          this.sidePanelDialog = CustomBranding;
          localStorage.removeItem('openFromCustomBranding');
        } else {
          this.sidePanelDialog = EditKulibri;
        }
      } else if (this.sidePanelDialog === EditLogo) {
        this.reRenderData = false;
        this.sidePanelDialog = CustomBranding;
      } else {
        this.sidePanelDialog = null;
        // this.displayNavBar();
        if (this.backupChoices) {
          this.$store.dispatch('updateChoices', this.backupChoices).then(() => {
            this.backupChoices = null;
          });
        }
      }
    },

    onSave() {
      console.info('Headline: onSAVE', this.sidePanelDialog, this.subpanel);

      // call the edit mode after choosing a background
      if (
        this.sidePanelDialog == EditBackground ||
        this.sidePanelDialog == ConfigureAnswer
      ) {
        this.sidePanelDialog = EditPoll;
        return;
      }

      // save on main panel is "next"
      // if (this.subpanel === false) {
      //   let options = this.poll.options;
      //   switch (this.poll.type) {
      //     case 1: // if Poll shpw alwas the Date selection
      //       this.subpanel = true;
      //       this.sidePanelDialog = EditDates;
      //       break;

      //     case 2: // if Event no action is needed
      //       this.sidePanelDialog = null;
      //       options.initialised = true;
      //       this.$store.commit('updateOptions', options);
      //       if (this.isNew) {
      //         this.isNew = false;
      //         this.sidePanelDialog = EditInvites;
      //       }
      //       break;

      //     case 3: // if Survey -> show the Choice selection dialog
      //       this.sidePanelDialog = EditChoices;
      //       this.subpanel = true;
      //       return;
      //   }
      //   console.log('Headline Save:', this.subpanel);
      //   return;
      // }

      this.subpanel = false;
      if (this.isNew) {
        this.isNew = false;
        this.sidePanelDialog = EditInvites;
      } else {
        this.subpanel = false;
        if (this.isNew) {
          this.isNew = false;
          this.sidePanelDialog = EditInvites;
          this.displayNavBar();
        } else {
          this.sidePanelDialog = null;
        }
      }
      if (this.subpanel == false) {
        this.displayNavBar();
      }
    },

    onBack() {
      console.log('onBack');
      if (this.isAuthenticated) {
        console.log('isAuthenticated');
        this.$router.push('/dashboard');
      } else {
        console.log('is NotAuthenticated');
        const homeUrl = process.env.VUE_APP_PUBLIC_HOME;
        console.log('Home url = ', homeUrl);
        window.location.href = homeUrl;
      }
    },

    editBackground() {
      this.sidePanelDialog = EditBackground;
    },

    editParticipantAttributes() {
      this.sidePanelDialog = EditBackground;
    },

    editCustomBranding() {
      this.sidePanelDialog = CustomBranding;
    },

    editCustomLogo() {
      this.sidePanelDialog = EditLogo;
    },

    editConfigureAnswer() {
      this.sidePanelDialog = ConfigureAnswer;
    },

    editingKulibriDone(ownerUser) {
      console.log('editingKulibriDone ownerUser:', ownerUser);
      let details = {
        title: this.poll.title,
        description: this.poll.description,
        options: this.poll.options,
        ownerUser: ownerUser,
        closed: this.poll.closed,
        design_id: this.poll.design_id,
        deadline: this.poll.deadline,
      };
      console.log('editingKulibriDone details:', details);
      this.$store.dispatch('updateDetails', details).then(() => {
        this.$store.commit('updateOptions', this.poll.options);
        this.editingKulibri = false;
      });
    },

    removePoll() {
      if (this.showCopyConfirm == true) {
        localStorage.setItem('old-poll', JSON.stringify(this.poll));
        this.$router.push({ path: '/pr/new' });
        window.location.reload();
        return;
      }

      const url = '/api/poll/' + this.poll.id;
      let router = this.$router;

      HTTP.delete(url)
        .then((response) => {
          console.debug(response.data);
          if (this.isAuthenticated) {
            router.push({ path: '/dashboard' });
          } else {
            const homeUrl = process.env.VUE_APP_PUBLIC_HOME;
            window.location.href = homeUrl;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    onRemoveCancel() {
      this.showConfirm = false;
      this.showCopyConfirm = false;
    },
    removePollDlg() {
      console.log('Remove the current poll');
      this.showConfirm = true;
    },
    calculateTextWidth() {
      this.needToDisplayReadMore = false;
      if (this.poll.description) {
        let divTagList = document.getElementsByClassName('description');
        if (divTagList.length > 0) {
          let screenWidth =
            document.getElementsByClassName('description')[0].offsetWidth || 0;
          let verticalScrollRows = 5;
          if (this.mobileView) {
            verticalScrollRows = 3;
          }
          let displayNcharacterInDescription =
            Math.floor(screenWidth * (1.8 / 14)) * verticalScrollRows; //screen width * (Font Constant / Font Size) * No of rows
          this.needToDisplayReadMore =
            this.poll.description.length > displayNcharacterInDescription ||
            this.poll.description.split('\n').length > verticalScrollRows;
        }
      }
      return this.needToDisplayReadMore;
    },
    openModal() {
      this.$refs.dlgDescriptionDialog.openModal();
    },
    closeDialog() {
      this.$refs.dlgDescriptionDialog.closeModal();
    },

    confirmCopy() {
      localStorage.setItem('old-poll', JSON.stringify(this.poll));
      if (this.copyOptions) {
        localStorage.setItem('copy-options', 'true');
      } else {
        localStorage.removeItem('copy-options');
      }
      this.$router.push({ path: '/pr/new' });
      window.location.reload();
      this.$refs.dlgCopyDialog.closeModal();
    },
    onDuplicate() {
      //this.showCopyConfirm = true;
      this.$refs.dlgCopyDialog.openModal();
    },
    onExport() {
      let participantArray = [];
      for (let i = 0; i < this.poll.participants.length; i++) {
        participantArray.push(this.poll.participants[i]['id']);
      }
      let userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const url = encodeURI('/api/download-excel/' + this.poll.id);
      HTTP.post(url, {
        timeZone: userTimezone,
        userIdLists: JSON.stringify(participantArray),
        type: this.poll.type,
      })
        .then((response) => {
          var fileLink = document.createElement('a');
          fileLink.href = response.data.path;
          fileLink.setAttribute('download', 'kulibri.xlsx');
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((error) => console.log(error));
    },
    onSendReminder() {
      this.backupChoices = null;
      this.sidePanelDialog = SendParticipantReminder;
      // this.hideNavBar();
    },
    onSendMessageToAdmin() {
      this.backupChoices = null;
      this.sidePanelDialog = SendMessageToAdmin;
      // this.hideNavBar();
    },
    forwardToCustomURL() {
      if (
        this.getSelectedTemplate.config.logoDetails.link &&
        this.getSelectedTemplate.config.logoDetails.link.replace(/\/+$/, '') !=
          window.location.origin
      ) {
        window.open(this.getSelectedTemplate.config.logoDetails.link);
      } else {
        this.onBack();
      }
    },
    // hideNavBar() {
    //   this.hideNavBarWhenSidePanelOpen = false;
    // },
    displayNavBar() {
      // this.hideNavBarWhenSidePanelOpen = true;
      this.updatePollStatus(false);
    },
    whenCancelDialog() {
      this.$refs.dlgCopyDialog.closeModal();
    },
  },

  computed: {
    ...mapState({
      details: (state) => state.details,
      options: (state) => state.options,
      poll: (state) => state.poll.poll,
      user: (state) => state.Login.user,
    }),

    ...mapGetters({
      isAuthenticated: 'isAuthenticated',
      userName: 'userName',
      isOwner: 'isOwner',
      design: 'design',
      isAdmin: 'isAdmin',
      images: 'images',
      getSelectedTemplate: 'getSelectedTemplate',
      designs: 'designs',
      hideWhenNewPoll: 'getPollStatus',
    }),

    pollCopyOptions() {
      return this.$t('polls.copyOptions');
    },

    headlineTheme() {
      if (this.design.align == 'center') {
        return 'color:#EE4540; background-color:rgba(255, 255, 255, 0.8);';
      }
      return 'color:#f5f5f7;';
    },

    headline() {
      let ownerName =
        this.ownerName.length > 0 ? this.ownerName : this.$t('polls.you');

      let headline = sprintf(
        this.$t('polls.created'),
        ownerName,
        this.lastUpdate
      );
      return headline;
    },

    headlineCss() {
      if (this.isLayoutCentered) return 'headline-content-center';
      return 'headline-content-right';
    },

    description() {
      return this.poll.description;
    },

    isNewPoll() {
      return this.poll.options.initialised == false;
    },

    visibleDateOptions() {
      if (!this.isOwner) return false;
      return this.poll.type == 1;
    },

    visibleChoiceOptions() {
      if (!this.isOwner) return false;
      return this.poll.type == 3;
    },

    sidePanelPropos() {
      if (this.sidePanelDialog === 'EditKulibri') {
        return { options: 'options' };
      } else if (this.sidePanelDialog === 'EditDates') {
        return {};
      } else if (this.sidePanelDialog.name == 'CustomBranding') {
        return { reRenderData: this.reRenderData };
      }

      return null;
    },

    visibleSidePanel() {
      return this.sidePanelDialog != null;
    },

    ownerName() {
      let name = '';

      let user_name = this.poll.user_name;

      if (!user_name) {
        user_name = this.poll.user.name;
      }
      if (user_name && user_name > 0) name = user_name;
      else name = user_name;
      return name;
    },

    lastUpdate() {
      if (this.poll.updated_at == null) {
        return shared.lastUpdate(this.poll.created_at, this.$t);
      }
      return shared.lastUpdate(this.poll.updated_at, this.$t);
    },
    titleConfirmRemove() {
      if (this.showConfirm) {
        return this.$t('polls.confirmRemove');
      }
      return this.$t('polls.copyConfirm');
    },
    isDisplayReadMore() {
      return this.calculateTextWidth();
    },

    mobileView() {
      return this.$store.state.mobileView;
    },
    isDatePoll() {
      return this.poll.type == 1;
    },
    customStyle() {
      // let logoImageURL = this.$store.getters.logoImage;
      // if (logoImageURL != null && logoImageURL.url != null) {
      //   let logoImage = logoImageURL.url;
      //   return `${logoImage}`;
      // }
      return require(`../../assets/logo_neu_weiss_blau_orange.png`);
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTextWidth);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/styles/style';

.headline {
  color: white;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.headline-content {
  position: relative;
}

.headline-content-right {
  margin-left: $mobile-margin-left;
}

.headline-content-center {
  margin-left: 20px;
  margin-right: 20px;
  text-align: center;
}

.headline__type {
  font-size: 18px;
  line-height: 30px;
  font-weight: $regular-weight;
}

.user-details {
  font-size: $small;
  line-height: 18px;
  font-weight: $regular-weight;
}

.headline__name {
  font-size: $very-large;
  white-space: pre-line;
  display: flex;
  font-weight: $semi-bold-weight;
}

.headline__description {
  margin-bottom: 12px;
  font-size: $small;
  line-height: 24px;
  white-space: pre-line;

  &.display-flex {
    display: flex;
  }
  .read-more {
    max-width: 25%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .read-less {
    max-height: 100px;
    // overflow: scroll;
    // overflow-x: hidden;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.headline-bar {
  display: flex;
  font-size: $fontsize-15;
  height: 48px;
}

.headline-items {
  display: flex;
  flex-direction: row;
}

.dropdown-toggle::after {
  display: none;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.text-project-header-admin {
  margin-top: 8px;
  display: flex;
}

.light-mode.headline-bg {
  background-color: rgba(0, 0, 0, 0.5);
}

.dark-mode.headline-bg {
  background-color: rgba(0, 0, 0, 0.6);
}

.read-button {
  font-weight: $medium-weight;
  font-size: $standard;
  // color: $white;
  cursor: pointer;
  white-space: pre-line;
}

.headline__left {
  flex: 1;
  overflow: hidden;
  line-height: 34px;
}

.headline__middle {
  position: absolute;
  right: 0px;
  border: 2px solid white;
  border-radius: 5px;
  padding: 8px;
  margin: 5px;
  margin-right: 16px;
  font-size: 14px;
  cursor: pointer;
}

a.headline__middle {
  text-decoration: none;
}

.headline__right {
  flex: 0 0 80px;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  margin-right: 10px;
}

.nav-item {
  cursor: pointer;
}

.description-text {
  font-size: $standard;
  white-space: pre-line;
  max-height: 420px;
  overflow: scroll;
}

::v-deep .read-button {
  span {
    text-decoration: underline;
  }
}

.poll-type-icon {
}

@media screen and (min-width: 960px) {
  .headline__type {
    font-size: $big-extra;
    line-height: 28px;
  }

  // .headline-items {
  //   font-size: $fontsize-15;
  // }

  .headline-content-right {
    margin-left: $desktop-margin-left;
    margin-right: 10px;
  }

  .text-project-header-admin {
    margin-top: 0pkulipx;
  }
}

@media screen and (max-width: 481px) {
  .headline__description {
    .read-less {
      max-height: 75px;
    }
  }
  .headline__name {
    font-size: $large;
  }
}

@media screen and (max-width: 390px) {
  .poll-type-icon {
  }
}
</style>
